import {
  CREATE_COLLECTIONS_FOLDER,
  GET_FOLDERS_COLLECTIONS,
  SAVE_COLLECTION,
  SAVE_COLLECTIONS,
  RENAME_COLLECTIONS_FOLDER,
  DELETE_COLLECTIONS_FOLDER,
  EDIT_COLLECTIONS,
  DELETE_COLLECTIONS, UNASSIGN_FROM_COLLECTIONS,
  ADD_TO_NEW_COLLECTION, COPY_TO_COLLECTION,
  COPY_TO_COLLECTION_UNSAVED, ADD_ACTIVE_FOLDER,
  ASSIGN_TO_COLLECTION,
  SET_MODE_COMPARE, CHANGE_COLLECTION_CHECKBOX
} from "../constans";

import {
  addCollectionFolder,
  createCollection,
  deleteCollectionFolder,
  deleteCollection,
  editCollection,
  getCollectionsFolders,
  getCollectionsForFolder,
  renameCollectionFolder,
  saveCollection,
  colorCollection,
  clearCollectionsColor,
  createTempCollectionFromSelection,
  removeSelectionFromCollection, getCollectionTable, addToTempCollection, addSelectionToCollection,
  getDetailedCollectionInfo, getCollectionInfo, removeSelectionFromTempCollection, colorCollections
} from "../../utils/builder/IScheduleLogic";
import {addSelectItems, closeTab, ElementsAction, replaceTab} from "./table";
import {calculationQuickInfo, showToast} from "../../utils/helpers";
import {tabType} from "../../utils/data";
import {useSelector} from "react-redux";
import {onSelectionChange, setQuickInfoCompare} from "./filter";

export const getFoldersCollections = () => async (dispatch) => {

  const folders = await getCollectionsFolders();

  dispatch({
    type: GET_FOLDERS_COLLECTIONS,
    payload: folders,
  });
};

export const collectionSave = (res) => async (dispatch) => {
  const collection = await createCollection(res.elements, res.properties, res.groups, res.customColumns);
  await saveCollection(collection, res.collectionName, res.folder, res.description, res.color);
  const collections = await getCollectionsForFolder(res.folder);

  if(res.type === tabType.unsaved) {
    dispatch(replaceTab({...res, collection}));
  }

  if(res.activeFolder === res.folder) {
    dispatch({
      type: SAVE_COLLECTION,
      payload: collections,
    });
  }
};

export const collectionsSave = (res) => {
  return {
    type: SAVE_COLLECTIONS,
    payload: res,
  };
};

export const createCollectionFolder = (res) => async (dispatch) => {

  await addCollectionFolder(res);

  dispatch({
    type: CREATE_COLLECTIONS_FOLDER,
    payload: res,
  });
};

export const collectionFolderRename = (res) => async (dispatch) => {

  await renameCollectionFolder(res.originalNameFolder, res.newNameFolder);

  dispatch({
    type: RENAME_COLLECTIONS_FOLDER,
    payload: res,
  });
};

export const collectionFolderDelete = (res) => async (dispatch) => {

  await deleteCollectionFolder(res);

  dispatch({
    type: DELETE_COLLECTIONS_FOLDER,
    payload: res,
  });
};

export const collectionEdit = (res) => async (dispatch) => {
  const {oldTitle, oldFolder, newTitle, newFolder, newDescription, newColor} = res;

  await editCollection(oldTitle, oldFolder, newTitle, newFolder, newDescription, newColor);

  dispatch({
    type: EDIT_COLLECTIONS,
    payload: res,
  });
};

export const collectionDelete = (res) => async (dispatch) => {
  const {title, folder, tabs, id=null} = res;
  const tab = tabs.find(tab => tab.id === id);

  await deleteCollection(title, folder);

  if(tab) {
    dispatch(closeTab(tab));
    unselectCollectionOnView();
  }

  dispatch({
    type: DELETE_COLLECTIONS,
    payload: res,
  });
};

export const selectCollectionOnView = (collections) => {
  colorCollections(collections);
};

export const unselectCollectionOnView = () => {
  colorCollections([]);
};

export const unassignFromCollection = (res) => async (dispatch) => {
    try {
        const newCollection = res.type !== tabType.unsaved ? await removeSelectionFromCollection(res.name, res.folder) : await removeSelectionFromTempCollection(res.collection);
        const tableCollection = await getCollectionTable(newCollection);
        unselectCollectionOnView();
        selectCollectionOnView([newCollection]);

      dispatch({
        type: UNASSIGN_FROM_COLLECTIONS,
        payload: {...tableCollection, id: res.id},
      });
      dispatch(addSelectItems({selectItems: {}, id: res.id}));
      showToast(true,"Unassigned from selection set");
    } catch (error) {
      showToast(false, error);
    }
};

export const addToNewCollection = (res) => async (dispatch) => {

  const collection = await createCollection(res.elements, res.properties, res.groups);
  const tableCollection = await getCollectionTable(collection);

  dispatch({
    type: ADD_TO_NEW_COLLECTION,
    payload: {tableCollection, collection}
  });
};

export const assignToCollection = (res) => async (dispatch) => {

  const collection = await addSelectionToCollection(res.title, res.folder);
  const tableCollection = await getCollectionTable(collection);

  dispatch({
    type: ASSIGN_TO_COLLECTION,
    payload: {tableCollection, title: res.title, folder: res.folder, id: res.id},
  });
};

export const copyToCollection = (res) => async (dispatch) => {
  const collection = await addSelectionToCollection(res.title, res.folder);
  const tableCollection = await getCollectionTable(collection);

  dispatch({
    type: COPY_TO_COLLECTION,
    payload: {tableCollection, id: res.id},
  });
};

export const copyToCollectionUnsaved = (res) => async (dispatch) => {
  const collection = await addToTempCollection(res.elements, res.collection);
  const tableCollection= await getCollectionTable(collection);

  dispatch({
    type: COPY_TO_COLLECTION_UNSAVED,
    payload: {tableCollection, id: res.id},
  });
};

export const addActiveFolder = (res) => {

  return {
    type: ADD_ACTIVE_FOLDER,
    payload: res,
  };
};

export const setUpModeCompare = (res) => {

  return {
    type: SET_MODE_COMPARE,
    payload: res,
  };
};

export const сhangeCollectionCheckbox  = (res) => async (dispatch) => {

  const infoCollection = await getDetailedCollectionInfo(res.collection);
  const sumCategories = Object.values(infoCollection).reduce((accumulator, currentEl) => {
    return calculationQuickInfo(accumulator, currentEl, "plus");
  })
  let totalQuickInfo = null;

  if(res.isChecked) {
    totalQuickInfo = calculationQuickInfo(res.quickInfoCompare, sumCategories, "minus");
  } else {
    totalQuickInfo = calculationQuickInfo(res.quickInfoCompare, sumCategories, "plus");
  }

  dispatch(setQuickInfoCompare(totalQuickInfo));

  dispatch({
    type: CHANGE_COLLECTION_CHECKBOX,
    payload: {...res, selectionDetails: { infoCollection, sumCategories, id: res.collection.creationTime, color: res.collection.color, name: res.collection.title }}
  });
};

